import type { ResolvedPlace } from '@gpx-spa/geo-domain'
import { geofenceCenterLatLng, geofenceToResolvedPlace } from '@gpx-spa/geo-domain'
import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore';

/** Coordinates used for map + routing (geofence wins over resolved address). */
export function getStopRoutingCoordinates(
  stop: ShipmentFormStopRow
): { lat: number; lng: number } | null {
  if (stop.geofence) {
    return geofenceCenterLatLng(stop.geofence)
  }
  const c = stop.resolved?.coordinates
  if (!c) return null
  return { lat: c.lat, lng: c.lng }
}

/** Map paint / routing helpers expect {@link ResolvedPlace}. */
export function toResolvedPlaceForMap(stop: ShipmentFormStopRow): ResolvedPlace | null {
  if (stop.resolved) return stop.resolved
  if (stop.geofence) return geofenceToResolvedPlace(stop.geofence)
  return null
}
